const dateFormat = require('date-format');

export function notEmpty(array) {
    if(!array) return false;
    return array.length > 0;
}

export function hasText(text){
    if(!text) return false;
    return text.trim().length > 0;
}

export function arrayIsEmpty(array) {
    if(!array) return true;
    return array.length === 0;
}

export function dateToDateString(date) {
    return dateFormat.asString("dd.MM.yyyy", date);
}

export function dateToMonthYearString(date) {
    const dateFormatted = dateToDateString(date);
    return dateFormatted.substring(dateFormatted.indexOf('.') + 1);
}

export function dateToDateTimeString(date) {
    return dateFormat.asString("dd.MM.yyyy, hh:mm:ss", date);
}

// export function dateToString(date) {
//     return dateFormat.asString("dd.MM.yyyy - hh:mm", date);
// }

export function dateAddMonth(date, monthCount){
    const d = new Date(date);
    d.setMonth(date.getMonth() + monthCount);
    return d;
}

export function cutToMax(text, maxLength) {
    if(text && text.length > maxLength){
        return text.substring(0, maxLength) + '...';
    }
    return text;
}

export function dateToFileNameString(date) {
    return dateFormat.asString("dd.MM.yyyy-hh_mm", date);
}

export function getMonthIndexFromDateString(dateString){
    return dateStringToDate(dateString).getMonth();
}

export function dateStringToDate(dateString) {

    if(!dateString){
        console.error('bad datestring: ' + dateString);
        return null;
    }

    if(dateString.length === 10){
        const dateTemplate = "dd.MM.yyyy";
        return dateFormat.parse(dateTemplate, dateString);
    }

    try {
        const dateTemplate = "dd.MM.yyyy hh:mm:ss.SSS";
        return dateFormat.parse(dateTemplate, dateString);
    } catch (e) {
        // console.error(e);
    }

    try {
        const dateTemplate = "dd.MM.yyyy hh:mm";
        return dateFormat.parse(dateTemplate, dateString);
    } catch (e) {
        // console.error(e);
    }

    throw new Error("unknown format: " + dateString);
}

export function toReadableString(o) {
    const type = typeof o;

    let s = o;

    if(s){
        if(type === 'object'){
            s = JSON.stringify(o, null, 2);
        } else {
            s = String(o);
        }

        try {
            s = s.replace(/\\"/g, '"');
        } catch (e) {
            console.error('can not read', o, e);
        }

        return s;
    }

    return String(s);
}

export function getMapSize(x) {
    let len = 0;
    for (let count in x) {
        len++;
    }
    return len;
}

export function logSafeObject(obj) {

    if(!obj){
        return '';
    }

    const fields = ['password', 'Password', 'Authorization', 'authorization'];

    const dateKeys = [];
    for (const key in obj) {
        if(obj[key] instanceof Date){
            dateKeys.push(key);
        }
    }

    const copy = JSON.parse(JSON.stringify(obj));
    dateKeys.forEach((key) => {
        copy[key] = new Date(copy[key]);
    });

    for (const key in copy) {

        if('headers' === key){

            const headers = copy[key];

            for(const headerKEY in headers){
                for(let i = 0; i < fields.length; i++){
                    if(headerKEY.indexOf(fields[i]) >= 0){
                        headers[headerKEY] = '*****';
                        break;
                    }
                }
            }

        } else {
            for(let i = 0; i < fields.length; i++){
                if(key.indexOf(fields[i]) >= 0){
                    copy[key] = '*****';
                    break;
                }
            }
        }

    }

    return copy;

}

export function deepCopy(obj) {
    const dateKeys = [];
    for (const key in obj) {
        if(obj[key] instanceof Date){
            dateKeys.push(key);
        }
    }

    const copy = JSON.parse(JSON.stringify(obj));
    dateKeys.forEach((key) => {
        copy[key] = new Date(copy[key]);
    });

    return copy;
}

export function interpetInvocationError(invocationError) {

    const errCodes = {
        'http status code 200' : 'Unexpected Response Code: 200',
        'http status code 201' : 'Unexpected Response Code: 201',
        'http status code 202' : 'Unexpected Response Code: 202',
        'http status code 400' : 'Bad Request - 400',
        'http status code 401' : 'Unauthorized - 401',
        'http status code 403' : 'Forbidden - 403',
        'http status code 404' : 'Not Found - 404',
        'http status code 405' : 'Method Not Allowed - 405',
        'http status code 50' : 'Internal Server Error'
    };

    let errorDetails = '';

    for (const [key, value] of Object.entries(errCodes)) {
        if(invocationError.indexOf(key) > 0){
            errorDetails = ': ' + value;
            break;
        }
    }

    return errorDetails;
}

export function getLanguageForLangId(langId){
    if(langId === 'DE') return "Deutsch";
    if(langId === 'EN') return "English";

    return "??" + langId + "??";
}

export function splitForCards(itemList, columns, addNew){
    const items     = itemList || [];
    const itemsCopy = items.slice();
    const rows      = [];

    if(addNew){
        itemsCopy.push({id:'new'});
    }

    while (itemsCopy.length) {
        let temp = itemsCopy.splice(0, columns);
        if (temp.length < columns) {
            temp.push(...Array(columns - temp.length).fill(null));
        }
        rows.push(temp);
    }

    return rows;
}

export function changeToDescription(change){

    let gender     = 'f';
    let rootTarget = 'Gemeinde';
    if (change.path.indexOf('district') > 0) {
        rootTarget = "Stadtteil";
        gender     = 'm';
    } else if (change.path.indexOf('calendar.event') >= 0){
        rootTarget = "Termin";
    } else if (change.path === 'city.basic-data'){
        rootTarget = "Basisdaten";
    } else if (change.path.indexOf('place') >= 0) {
        rootTarget = "Ort / Einrichtung";
    } else if (change.path.indexOf('task') >= 0) {
        rootTarget = "Aufgabe";
    }

    let changeTarget = change.path;
    if(change.path.indexOf('.description') > 0){
        changeTarget = "Beschreibung";

        if(change.data['title']){
            changeTarget = "Title";
        } else if(change.data['subTitle']){
            changeTarget = "Untertitel / Slogan";
        }

    } else if (change.path.indexOf('geo-info') > 0) {
        changeTarget = "Geo-Position";
    } else if (change.path.indexOf('address') > 0) {
        changeTarget = "Adresse";
    } else if (change.path.indexOf('category') > 0) {
        changeTarget = "Kategorie";
    } else if (change.path.indexOf('organizer.place-id') > 0) {
        changeTarget = "Organisator-Auswahl";
    } else if (change.path.indexOf('type') > 0) {
        changeTarget = "Typ";
    } else if (change.path.indexOf('images.emblem') > 0) {
        changeTarget = "Emblem/Logo";
    } else if (change.path.indexOf('images.main') > 0) {
        changeTarget = "Bild";
    } else if (change.path.indexOf('contact-data') > 0) {
        changeTarget = "Kontaktdaten";
    } else if (change.path.indexOf('impressum') > 0) {
        changeTarget = "Impressum";
    } else if (change.path.indexOf('opening-hours') > 0) {
        changeTarget = "Öffnungszeiten";
    } else if (change.path.indexOf('tags') > 0) {
        changeTarget = "Tags / Suchbegriffe";
    } else if (change.path.indexOf('priority') > 0) {
        changeTarget = "Priorität";
    } else if (change.path.indexOf('state') > 0) {
        changeTarget = "Zustand";
    }

    if (change.operation === 'update') {

        let article = " der ";
        if (gender === 'm') {
            article = " von ";
        }
        return rootTarget + ": " + changeTarget + " angepasst";

    } else if (change.operation === 'create-new') {

        let article = "Neue ";
        if(gender === 'm'){
            article = "Neuen ";
        }

        return article + " " + rootTarget + " erstellt";

    } else if (change.operation === 'upload-replace') {

        let article = "Neue ";
        if(gender === 'm'){
            article = "Neuen ";
        }

        return rootTarget + ": Neues " + changeTarget + " hochgeladen";

    } else if (change.operation === 'upload-add') {

        return rootTarget + ": Neues " + changeTarget + " hochgeladen";

    } else if (change.operation === 'update-add') {

        return rootTarget + ": " + changeTarget + " angepasst";

    } else if (change.operation === 'update-del') {

        return rootTarget + ": " + changeTarget + " entfernt";

    } else if (change.operation === 'delete'){

        return rootTarget + ": " + changeTarget + " entfernt";

    } else if (change.operation === 'revert'){

        if(change.context['releaseVersion']){
            return rootTarget
                    + " auf die Release-Version v."
                    + change.context['releaseVersion']
                    + " (" + change.context['releaseDate'] + ") "
                    + " zurückgesetzt";
        }

        return rootTarget + " wiederhergestellt";

    }

    return change.operation + ":" + change.path;
}

export function darker(color) {

    const percent = -20;

    let R = parseInt(color.substring(1,3),16);
    let G = parseInt(color.substring(3,5),16);
    let B = parseInt(color.substring(5,7),16);

    R = parseInt(R * (100 + percent) / 100);
    G = parseInt(G * (100 + percent) / 100);
    B = parseInt(B * (100 + percent) / 100);

    R = (R<255)?R:255;
    G = (G<255)?G:255;
    B = (B<255)?B:255;

    R = Math.round(R)
    G = Math.round(G)
    B = Math.round(B)

    var RR = ((R.toString(16).length==1)?"0"+R.toString(16):R.toString(16));
    var GG = ((G.toString(16).length==1)?"0"+G.toString(16):G.toString(16));
    var BB = ((B.toString(16).length==1)?"0"+B.toString(16):B.toString(16));

    return "#"+RR+GG+BB;
}
